import { SvgIcon, SvgIconProps } from '@mui/material';

/** @deprecated Use theme-next icons or move into theme-next folder if it doesn't exists */
export const ArrowUpIcon = (props: SvgIconProps) => {
    return (
        <SvgIcon viewBox="0 0 20 20" {...props}>
            <path d="M6.175 12.8417L10 9.02501L13.825 12.8417L15 11.6667L10 6.66667L5 11.6667L6.175 12.8417Z" />
        </SvgIcon>
    );
};
